import { render, staticRenderFns } from "./delete-dialog.vue?vue&type=template&id=0f1b0bd8&"
import script from "./delete-dialog.vue?vue&type=script&lang=js&"
export * from "./delete-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports